// extracted by mini-css-extract-plugin
export default {"changeRemuneration":"ChangeRemunerationDrawer_changeRemuneration__nFBWf","inputWrap":"ChangeRemunerationDrawer_inputWrap__UsXe-"};